import { services } from './servicesData';
import ServiceRow from './ServiceRow';

export default function ServiceList() {
  return (
    <section className="relative py-12 px-6">
      <div className="max-w-6xl mx-auto">
        {services.map((service, i) => (
          <ServiceRow key={service.title} service={service} index={i} />
        ))}
      </div>
    </section>
  );
}